import { Button } from "Components/_Shared/Buttons/Button";
import { DialogModal } from "Components/_Shared/DialogModal";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { DialogErrorText } from "./DialogErrorText";
import type { DuplicateConflict } from "./useDuplicateVersion";

type Props = {
  readonly conflict: DuplicateConflict;
};

export const DuplicateConflictDialog = ({ conflict }: Props) => {
  const { t } = useResource();

  return (
    <DialogModal
      size="sm"
      isOpen={conflict.sourceVersion !== null}
      onClose={conflict.cancel}
      isPending={conflict.isConfirming}
      closeLabel={t(Resources.Common.Cancel)}
      title={t(Resources.AnalysisDetail.Duplicate.Conflict.Title)}
      subtitle={t(Resources.AnalysisDetail.Duplicate.Conflict.Text, { version: conflict.sourceVersion?.version })}
      content={conflict.errorText && <DialogErrorText text={conflict.errorText} />}
      secondaryAction={
        conflict.canOpenExisting && (
          <Button color="secondary" disabled={conflict.isConfirming} onClick={conflict.openExisting}>
            {t(Resources.AnalysisDetail.Duplicate.Conflict.OpenExisting)}
          </Button>
        )
      }
      primaryAction={
        <Button loading={conflict.isConfirming} onClick={conflict.confirm}>
          {t(Resources.AnalysisDetail.Duplicate.Conflict.Confirm)}
        </Button>
      }
    />
  );
};
